<template>

  <v-select 
    v-model="selected"
    :options="options"
    :placeholder="placeholder"
    :multiple="multiple">
    </v-select>

</template>

<script>
export default {
  name: 'Select',
  props: {
    value: {
      type: [String, Array, Boolean]
    },
    placeholder: {
      type: String
    },
    options: {
      type: Array
    },
    multiple: {
      type: Boolean
    }
  },
  data () {
    return {
      selected: null
    }
  },
  watch: {
    selected (val) {
      this.change(val)
    }
  },
  computed: {
    nValue () {
      return this.multiple && !this.value ? [] : this.value
    }
  },
  created () {
    if (this.multiple) {
      this.selected = this.options.filter(val => this.nValue.includes(val.value))
    } else {
      this.selected = this.options.find(val => val.value === this.nValue)
    }
  },
  methods: {
    change (val) {
      const value = Array.isArray(val) ? val.map(v => v.value) : (val ? val.value : val)

      if (value !== this.value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/Select.vue